import { Dispatch, SetStateAction, useEffect, useState } from 'react';

// Taken from CST: https://stash.atlassian.com/projects/CST/repos/customer-support-portal/browse/agent-portal/src/hooks/use-state-with-delay/use-state-with-delay.ts

/**
 * Manages some state that will be updated after a certain delay when it is set.
 *
 * @param delayInMs milliseconds to to delay update
 */
const useStateWithDelay = (
    delayInMs: number
): [string, Dispatch<SetStateAction<string>>] => {
    const [userInput, setUserInput] = useState<string>(''); // Stores search input as input field is changed
    const [searchInput, setSearchInput] = useState<string>(''); // Used to search backend, updates after a set delay

    useEffect(() => {
        const timer = setTimeout(() => {
            setSearchInput(userInput);
        }, delayInMs);
        return () => clearTimeout(timer);
    }, [userInput, delayInMs]);

    return [searchInput, setUserInput];
};

export default useStateWithDelay;
